import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-factory-upload-review",
  "use": "icon-soc-factory-upload-review-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-factory-upload-review\">\n  <g fill=\"currentColor\">\n    <path d=\"M256 160h384l128 128v576c0 35-29 64-64 64H256c-35 0-64-29-64-64V224c0-35 29-64 64-64z\" />\n    <path d=\"M640 160v128h128\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" />\n    <path d=\"M336 448h352v48H336zm0 128h352v48H336zm0 128h224v48H336z\" fill=\"#fff\" />\n    <path d=\"M704 704l48 48 96-112\" fill=\"none\" stroke=\"#fff\" stroke-width=\"40\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-factory-upload-review.svg
// module id = CU88
// module chunks = 546